(function () {
    const params = window.location.search;
    const utmSource = new URLSearchParams(params).get('utm_source');

    const dwnButtons = document.querySelectorAll('[data-dwn-btn]');
    const apkButtons = document.querySelectorAll('[data-utm-apk]');
    let refParamDwn = '';
    let refParamApk = '';

    if (utmSource) {
        refParamDwn = '&referrer=' + encodeURI(params.replace('?', ''));
        refParamApk = encodeURI(params);
    } else {
        const refUrl = document.referrer;

        if (refUrl) {
            const referrer = new URL(refUrl).hostname.replace('www.', '');

            if (referrer === 'google.com') {
                refParamDwn = '&referrer=utm_source=landing&utm_medium=organic&utm_campaign=google-organic';
                refParamApk = '?utm_source=landing&utm_medium=organic&utm_campaign=google-organic';
            } else {
                refParamDwn = '&referrer=utm_source=landing&utm_medium=landing&utm_campaign=' + referrer;
                refParamApk = '?utm_source=landing&utm_medium=landing&utm_campaign=' + referrer;
            }
        } else {
            refParamDwn = '&referrer=utm_source=direct&utm_medium=landing&utm_campaign=direct';
            refParamApk = '?utm_source=direct&utm_medium=landing&utm_campaign=direct';
        }
    }

    if (dwnButtons) dwnButtons.forEach(el => el.href = el.href + refParamDwn);
    if (apkButtons) apkButtons.forEach(el => el.href = el.href + refParamApk);
})();

